const revertTimeouts = new WeakMap();

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-promo-code-banner-button]');
  if (!button) return;

  const textEl = button.querySelector('[data-promo-code-banner-text]');
  const originalEl = button.querySelector('[data-promo-code-banner-original]');
  const code = button.getAttribute('data-promo-code');

  try {
    await navigator.clipboard.writeText(code);
  } catch (error) {
    console.error('Failed to copy promo code: ', error);
    return;
  }

  clearTimeout(revertTimeouts.get(button));
  textEl.textContent = 'Code copied';

  revertTimeouts.set(
    button,
    setTimeout(() => {
      textEl.innerHTML = originalEl.innerHTML;
    }, 10000)
  );
});
